const CONTAINER_ID = "tapcart-storefront-bridge-toasts";
const TOAST_DURATION_MS = 3000;
const accentFor = (type) => {
    if (type === "error")
        return "#D64545";
    if (type === "success")
        return "#1D9E75";
    return "#555555";
};
const ensureContainer = () => {
    let el = document.getElementById(CONTAINER_ID);
    if (!el) {
        el = document.createElement("div");
        el.id = CONTAINER_ID;
        el.setAttribute("role", "status");
        el.setAttribute("aria-live", "polite");
        el.style.cssText =
            "position:fixed;bottom:16px;left:50%;transform:translateX(-50%);" +
                "z-index:2147483647;display:flex;flex-direction:column;gap:8px;" +
                "pointer-events:none;max-width:90vw;";
        document.body.appendChild(el);
    }
    return el;
};
export const showToast = (data, handlers) => {
    var _a, _b, _c;
    if (typeof document === "undefined") {
        (_a = handlers.onSuccess) === null || _a === void 0 ? void 0 : _a.call(handlers, {});
        return;
    }
    const payload = (data !== null && data !== void 0 ? data : {});
    if (!payload.message) {
        (_b = handlers.onError) === null || _b === void 0 ? void 0 : _b.call(handlers, new Error("app/toast: message required"));
        return;
    }
    const toast = document.createElement("div");
    toast.textContent = payload.message;
    toast.style.cssText =
        "background:#1f1f1f;color:#ffffff;padding:10px 16px;border-radius:8px;" +
            "font:14px/1.4 -apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif;" +
            "box-shadow:0 4px 12px rgba(0,0,0,0.25);opacity:0;transition:opacity 150ms;" +
            `border-left:3px solid ${accentFor(payload.type)};`;
    const container = ensureContainer();
    container.appendChild(toast);
    // Next frame so the opacity transition runs.
    requestAnimationFrame(() => {
        toast.style.opacity = "1";
    });
    window.setTimeout(() => {
        toast.style.opacity = "0";
        window.setTimeout(() => {
            toast.remove();
            if (!container.childElementCount)
                container.remove();
        }, 200);
    }, TOAST_DURATION_MS);
    (_c = handlers.onSuccess) === null || _c === void 0 ? void 0 : _c.call(handlers, {});
};
